import Vue from 'vue';
import App from './App.vue';
import router from './router'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import axios from 'axios';
import Url from './config';
import store from './store'
import MetaInfo from 'vue-meta-info'

Vue.config.productionTip = false;
Vue.prototype.axios = axios;	
Vue.prototype.Url = Url;





Vue.use(ElementUI);
Vue.use(MetaInfo);

new Vue({
	router,
	store,	
	render: h => h(App)
}).$mount('#app')
